/**
 * UsbTransport — narrow data-plane seam below DeviceService (AD-5).
 *
 * Covers byte flow and interface claim/release only. Connection lifecycle
 * (plug/unplug) deliberately stays on navigator.usb.addEventListener in
 * DeviceService; device open/selectConfiguration/endpoint discovery also stay
 * on USBDevice (setup, not data plane). Kept separate from IDeviceService.
 */
export interface UsbTransport {
  transferIn(endpointNumber: number, length: number): Promise<USBInTransferResult>;
  transferOut(endpointNumber: number, data: BufferSource): Promise<USBOutTransferResult>;
  claimInterface(interfaceNumber: number): Promise<void>;
  releaseInterface(interfaceNumber: number): Promise<void>;
  clearHalt(direction: USBDirection, endpointNumber: number): Promise<void>;
}

/** Pure pass-through adapter over a WebUSB USBDevice. */
export class WebUsbTransport implements UsbTransport {
  constructor(private readonly device: USBDevice) {}

  transferIn(endpointNumber: number, length: number): Promise<USBInTransferResult> {
    return this.device.transferIn(endpointNumber, length);
  }

  transferOut(endpointNumber: number, data: BufferSource): Promise<USBOutTransferResult> {
    return this.device.transferOut(endpointNumber, data);
  }

  claimInterface(interfaceNumber: number): Promise<void> {
    return this.device.claimInterface(interfaceNumber);
  }

  releaseInterface(interfaceNumber: number): Promise<void> {
    return this.device.releaseInterface(interfaceNumber);
  }

  clearHalt(direction: USBDirection, endpointNumber: number): Promise<void> {
    return this.device.clearHalt(direction, endpointNumber);
  }
}
